import React from 'react';
import { componentService } from 'js/services/component.service';

export const GamblingSessionLimits = React.lazy(() => import(/* webpackChunkName: "gambling-session-limits" */ './GamblingSessionLimits'));

// <hub2-gambling-session-limits></hub2-gambling-session-limits>
componentService.registerWebContentComponents({ GamblingSessionLimits });
